"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All error translations
var Errors = {
  oh_no: {
    nl: "Oh nee! We kunnen de pagina die je zoekt niet terugvinden =(",
    fr: "Oh non! Nous ne pouvons pas trouver la page que vous recherchez =(",
    en: "Oh no! We can't find the page you're looking for =(",
    de: "Oh nein! Wir können die von Ihnen gesuchte Seite nicht finden =("
  },
  child_focus_lang: {
    nl: "nl-BE",
    fr: "fr-BE",
    en: "en",
    de: "de"
  },
  something_went_wrong: {
    nl: "Er ging iets mis",
    fr: "Quelque chose a mal tourné",
    en: "Something went wrong",
    de: "Etwas ist schiefgegangen"
  },
  something_went_wrong_not_you: {
    nl: "Er ging iets mis! Het ligt niet aan jou maar aan ons",
    fr: "Quelque chose s'est mal passé! Ce n'est pas à vous mais à nous",
    en: "Something went wrong! It's not you; it's us",
    de: "Etwas ist schiefgegangen! Es liegt nicht an Ihnen, sondern an uns"
  },
  no_results: {
    nl: "Sorry! Er konden geen resultaten worden gevonden",
    fr: "Désoler! Aucun résultat n'a pu être trouvé",
    en: "Sorry! No results could be found",
    de: "Entschuldigung! Es konnten keine Ergebnisse gefunden werden"
  }
};
var _default = Errors;
exports["default"] = _default;